/**
 * Index Module02 View
 */
class IndexModule02View {

	constructor(presenter, sectionId) {

		this.parent = $("#shopify-section-" + sectionId);
		this.presenter = presenter;

		/*
		 * Listeners
		 */

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

}